import React, { useState } from 'react';
import HGForm from 'components/HGForm';
import { Auth } from '@aws-amplify/auth';

const InstallerForm = ({ setNewUser }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const signUp = async (creds) => {
        setErrorMessage(null);
        try {
            const { firstName, lastName, email, password, companyId, phone } =
                creds;
            const newUserCredentials = {
                username: email,
                password,
                attributes: {
                    email,
                    name: firstName,
                    family_name: lastName,
                    phone_number: '+' + phone,
                    'custom:company_id': companyId,
                    'custom:role': 'Installer',
                },
            };

            const user = await Auth.signUp(newUserCredentials);
            if (user) setNewUser(user);
        } catch (error) {
            console.log('INSTALLER ERROR MESSAGE: ', error);
            error.message = error.message.replace(
                'PreSignUp failed with error Error:',
                ''
            );
            setErrorMessage(error.message);
        }
    };

    return (
        <HGForm
            fields={{
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                phone: 'Phone',
                password: 'Password',
                confirmPassword: 'Confirm Password',
                companyId: 'Company Id',
            }}
            buttonText="create account"
            handleSubmit={signUp}
            errorMessage={errorMessage}
        />
    );
};

export default InstallerForm;
